var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`${_vm.prefixCls}-honors`,attrs:{"id":"aochenHonors"}},[_c('Separate',{staticClass:"wow animate__fadeInUp",attrs:{"title":"资质荣誉","desc":"QUALIFICATIONS HONORS","data-wow-duration":"1s"}}),_c('div',{class:`${_vm.prefixCls}-honors-content`},[_c('time-line',{staticStyle:{"margin-left":"50px"},attrs:{"value":_vm.honorList}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }